import { createLogger } from '@owl-lib/logger';
import { deserialize, fetchWrapper } from '../fetch';
import type { Disruption } from './interface';
const logger = createLogger(__filename);

const statusApiClient = {
  fetchDisruptions: async (): Promise<Disruption[]> => {
    const url = new URL(`/app/v1/disruptions`, API_BASE_URL);
    logger.trace('statusApiClient.fetchDisruptions()');
    return deserialize(
      await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
    );
  },
};

export default statusApiClient;
